<template>
    <div>
        <v-row class="px-2 pt-2">
            <!-- Merchants -->
            <v-col md="4" class="py-0">
                <v-autocomplete
                    v-model="merchant"
                    label="Select a merchant"
                    :items="merchants"
                    item-value="uuid"
                    item-text="name"
                    dense
                    return-object
                    clearable
                    @change="getReport(); loading = true;"
                    @click:clear="clearMerchant()"
                ></v-autocomplete>
            </v-col>

            <!-- From Date -->
            <v-col md="2" class="py-1">
                <v-menu
                    v-model="fromDateModal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                ><template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="fromDate"
                        label="From Date"
                        append-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        class="mt-0 pt-0"
                    ></v-text-field
                ></template>
                    <v-date-picker
                        v-model="fromDate"
                        @input="fromDateModal = false"
                        @click:date="this.getReport"
                        :max="maxdate"
                    ></v-date-picker>
                </v-menu>
            </v-col>
        </v-row>
        

        <v-row class="px-4">
            <v-col md="12" class="pa-2">
                <v-data-table
                    v-if="report"
                    :headers="headers"
                    :items="report"
                    :items-per-page="10"
                    class="elevation-0"
                >
                </v-data-table>
            </v-col>
        </v-row>

        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';

export default {
    data() {
        return {
            merchants: null,
            merchant: {},
            loading: false,
            report: null,
            fromDateModal: null,
            fromDate: moment().startOf('month').format('YYYY-MM-DD'),
            headers: [{ text: 'Date', value: 'processingTime', sortable: true },
                      { text: 'Transaction ID', value: 'uuid', sortable: true },
                      { text: 'Payment Type', value: 'paymentType', sortable: true, align: "center" },
                      { text: 'Amount', value: 'amount', sortable: true, align: "center" },
                      { text: 'Currency', value: 'currency', sortable: true, align: "center" },
                      { text: 'Card Holder', value: 'holder', sortable: false, align: 'center' },
                      { text: 'Merchant Transaction ID', value: 'merchantTransactionId', sortable: false, align: 'center' },
                      { text: 'Ref UUID', value: 'ref_uuid', sortable: false, align: 'center' },
                      { text: 'Ref Payment Type', value: 'ref_paymentType', sortable: false, align: 'center' },
                      { text: 'Ref Amount', value: 'ref_amount', sortable: false, align: 'center' }]
        }
    },
    beforeMount() {
        this.getMerchants();
    },
    computed: {

    },
    methods: {
        getMerchants() {
            if(this.$store.getters.role <= 3) {
                axios({
                method: 'get',
                url: `get-merchants-live`,
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.merchants = response.data;
                    this.getReport();
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
            else {
                axios({
                method: 'post',
                url: `get-merchants-live-client`,
                data: { userId: this.$store.state.user.id },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.merchants = response.data;
                    if(response.data.length) {
                        this.merchant = response.data[0];
                        this.getReport();
                    }
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        },
        getReport() {
            if(this.$store.state.user.id <= 3) {
                axios({
                method: 'post',
                url: `unclaimed-pre-auths`,
                data: { merchant: typeof this.merchant !== 'undefined' ? this.merchant.uuid : null, fromDate: this.fromDate },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.report = response.data;
                    this.loading = false;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
            else {
                axios({
                method: 'post',
                url: `unclaimed-pre-auths`,
                data: { merchant: this.merchant.uuid, fromDate: this.fromDate },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    this.report = response.data;
                    this.loading = false;
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
            
        },
        clearMerchant() {
            this.merchant = {};
            this.getReport();
        },
        download() {
            axios({
                method: 'post',
                url: 'download-merchants-value-volume',  
                data: { merchant: Object.keys(this.merchant).length === 0 ? this.merchants : [this.merchant],
                        fromDate: this.fromDate,
                        toDate: this.toDate },              
                responseType: 'blob',
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'merchants-value-volume-report.csv');
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(e => {
                    this.errors.push(e)
            })
        }
    }
}
</script>

<style>

</style>